var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.FooterData)?_c('footer',[_c('div',{staticClass:"line"}),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.FooterData.Footer_Text)}}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line_2"},[_c('div',{staticClass:"circle"},[_c('img',{attrs:{"src":"img/map.svg","alt":""}})])])
}]

export { render, staticRenderFns }